export default {
  name: "spacer",
  components: {},
  props: ["place", "currentStep"],
  computed: {
    isPass() {
      return this.currentStep > this.place;
    }
  }
};
